var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"mx-3 pa-0",attrs:{"items":_vm.levels,"hide-details":""},on:{"change":_vm.changeLevel},model:{value:(_vm.currentLevel),callback:function ($$v) {_vm.currentLevel=$$v},expression:"currentLevel"}})}
var staticRenderFns = []

export { render, staticRenderFns }